import React from "react";
import { Card, Button } from "react-bootstrap";
import { FiUser, FiCalendar } from "react-icons/fi";

export default function RecentApplications() {
  const data = [
    {
      name: "Andrew Stuart",
      role: "Frontend Developer",
      img: "/assets/img/agents/agent-01.jpg",
      status: "Interview",
      color: "#c026d3",
      bg: "#f5d0fe",
    },
    {
      name: "Jessica Brown",
      role: "UI/UX Designer",
        img: "/assets/img/agents/agent-02.jpg",

      status: "Shortlisted",
      color: "#0369a1",
      bg: "#e0f2fe",
    },
  ];

  return (
    <Card className="ra2-card h-100">
      <Card.Body>

        <h5 className="ra2-title">Recent Applications</h5>

        {data.map((item, i) => (
          <div className="ra2-item" key={i}>

            {/* TOP */}
            <div className="ra2-top">
              <div className="ra2-left">
                <img src={item.img} alt="" />
                <div>
                  <h6>{item.name}</h6>
                  <p>{item.role}</p>
                </div>
              </div>

              <div
                className="ra2-status"
                style={{ background: item.bg, color: item.color }}
              >
                <span className="dot"></span>
                {item.status}
              </div>
            </div>

            {/* DIVIDER */}
            <div className="ra2-divider"></div>

            {/* BOTTOM */}
            <div className="ra2-footer">
              <span>
                <FiUser /> 7 years exp
              </span>

              <span>
                <FiCalendar /> Applied: Dec 27, 2025
              </span>
            </div>

          </div>
        ))}

        <Button className="ra2-btn w-100">
          View All Schedule
        </Button>

      </Card.Body>

      {/* ================= INTERNAL CSS ================= */}
      <style>{`

        .ra2-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
          padding: 10px;
        }

        .ra2-title {
          font-weight: 600;
          margin-bottom: 18px;
        }

        .ra2-item {
          border: 1px solid #eef2f7;
          border-radius: 12px;
          padding: 14px;
          margin-bottom: 15px;
          background: #fff;
        }

        .ra2-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .ra2-left {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .ra2-left img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          object-fit: cover;
        }

        .ra2-left h6 {
          margin: 0;
          font-weight: 600;
          font-size: 15px;
        }

        .ra2-left p {
          margin: 0;
          font-size: 13px;
          color: #6b7280;
        }

        /* STATUS BADGE */
        .ra2-status {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 4px 10px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 500;
        }

        .ra2-status .dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: currentColor;
        }

        /* DIVIDER */
        .ra2-divider {
          height: 1px;
          background: #f1f5f9;
          margin: 12px 0;
        }

        /* FOOTER */
        .ra2-footer {
          display: flex;
          justify-content: space-between;
          font-size: 13px;
          color: #6b7280;
        }

        .ra2-footer span {
          display: flex;
          align-items: center;
          gap: 6px;
        }

        /* BUTTON */
        .ra2-btn {
          margin-top: 10px;
          height: 44px;
          border-radius: 8px;
          font-weight: 500;
          background: linear-gradient(90deg, #ff6a00, #ff3d00);
          border: none;
        }

        /* MOBILE */
        @media (max-width: 768px) {

          .ra2-footer {
            flex-direction: column;
            gap: 6px;
          }

        }

        @media (max-width: 1024px) {
          .ra2-card {
            margin-top: 20px;
          }
        }

      `}</style>
    </Card>
  );
}